/**
 * Walk a `ValidationResults` tree and collect the distinct human-readable
 * messages, so the reason a schedule is invalid can be surfaced to the user.
 */
export const collectValidationMessages = (node: unknown): string[] => {
  if (!node || typeof node !== 'object') {
    return []
  }

  if (Array.isArray(node)) {
    return [...new Set(node.flatMap(collectValidationMessages))]
  }

  const record = node as Record<string, unknown>

  if (typeof record.message === 'string') {
    return [record.message]
  }

  return [...new Set(Object.values(record).flatMap(collectValidationMessages))]
}
